import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogClickDirective } from 'app/directives/log-click.directive';
import { LogChangeDirective } from 'app/directives/log-change.directive';

const SHARED_DIRECTIVES = [
  LogClickDirective,
  LogChangeDirective
];

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    ...SHARED_DIRECTIVES
  ],
  exports: [
    ...SHARED_DIRECTIVES
  ]
})
export class SharedDirectivesModule { }
